export interface WallTileImage {
  image: CanvasImageSource;
  pxPerMm: number;
}

// Repeats the wall tile across the canvas at `scale` px/mm. A tile rendered at
// another px/mm is stretched to fit, which keeps slider drags responsive until
// a sharp tile for the new scale is ready.
export const drawWall = (
  ctx: CanvasRenderingContext2D,
  tile: WallTileImage,
  scale: number,
  width: number,
  height: number
) => {
  const pattern = ctx.createPattern(tile.image, "repeat");
  if (!pattern) return;
  pattern.setTransform(new DOMMatrix().scaleSelf(scale / tile.pxPerMm));
  ctx.clearRect(0, 0, width, height);
  ctx.fillStyle = pattern;
  ctx.fillRect(0, 0, width, height);
};
